<script setup lang="ts">
const { cart } = useCart();
const { onSubmit, onReset, isSubmitting, result, values } = useApplyLillopointsForm();
const amount = computed(() => values.points / cart.value.lillopoints.conversion_rate);
</script>

<template>
  <UiFormWrapper :result="result" @submit="onSubmit" @reset="onReset">
    <div class="paragraph-lg text-center">
      Utilisez <em>{{ integer(values.points) }}</em> Lillopoints pour obtenir un rabais de <em>{{ currency(amount) }}</em> sur cette commande!
    </div>
    <FieldSlider name="points" label="Lillopoints à utiliser" :max="cart.lillopoints.max_points" :min="0" :step="500" required hide-label />
    <UiSubmitButton :is-submitting="isSubmitting" class="w-full">
      Appliquer
    </UiSubmitButton>
  </UiFormWrapper>
</template>
